import { Navigate, createFileRoute } from '@tanstack/react-router';
import { useAslen } from '@aslen/core/hooks';
import { LoginPage } from '@/features/auth/auth-pages';

export const Route = createFileRoute('/login')({
  validateSearch: (s: Record<string, unknown>): { tab?: 'password' | 'magic' | 'invite' } => ({
    tab: s.tab === 'password' || s.tab === 'magic' || s.tab === 'invite' ? s.tab : undefined,
  }),
  component: function Login() {
    const { session, authReady } = useAslen();
    const { tab } = Route.useSearch();
    if (authReady && session) return <Navigate to="/" />;
    return <LoginPage initialTab={tab} />;
  },
});
